import { render } from "./UiTextarea.pug?vue&type=template&id=6c36c338&lang=pug"
import script from "./UiTextarea.js?vue&type=script&lang=js"
export * from "./UiTextarea.js?vue&type=script&lang=js"

import "./UiTextarea.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__